<template>
  <div id="home" class="home">
    <skeleton v-if="skeletonLoading" />
    <template v-else>
      <headerTopBar :bgInfo="headerBg" :info="searchInfo" :hasUnreadMsg="hasUnreadMsg"/>
      <!-- nav tab -->
      <tabNav class="tab-nav-fixed" v-if="curTab != 'home' && homeConfig.tabEnable" :curTab="curTab" :tabList="tabList" :tabListFixed="tabListFixed" @changeTab="changeTab" />

      <div v-if="curTab == 'home'" class="home-container">
          <div id="homeWarp" class="middle-bg"></div>
          <!-- nav tab -->
          <tabNav v-if="curTab == 'home' && homeConfig.tabEnable" :curTab="curTab" :tabList="tabList" :tabListFixed="tabListFixed" @changeTab="changeTab" />

          <div class="home-warp">
            <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
              <template #pulling><refreshLoading text="下拉刷新" color="#fff" textColor="#fff"/></template>
              <template #loosing><refreshLoading text="下拉刷新" color="#fff" textColor="#fff"/></template>
              <template #loading><refreshLoading text="加载中" color="#fff" textColor="#fff"/></template>
              <template #success><refreshLoading text="加载完成" color="#fff" textColor="#fff"/></template>
              <!-- main -->
              <div class="home-body home-body-pt">

                <!-- banner swiper -->
                <div class="home-banner" v-if="bannerList.length">
                  <van-swipe ref="vanSwiper" :initial-swipe="curSwiperIndex" :autoplay="3000" indicator-color="white" class="banner" @change="swiperChange">
                    <van-swipe-item v-for="(item, index) in bannerList" :key="index"  @click="bannerClick(item, index)">
                      <img :src="item.imageUrl | imageToHttps"/>
                    </van-swipe-item>
                  </van-swipe>
                </div>

                <!-- 分类 -->
                <menuItems v-if="homeConfig.categoryInfo && homeConfig.categoryInfo.categoryEnable" :bgInfo="categoryBgColor" :items="categorys"/>

                <!-- 中通广告图 -->
                <div class="middle-adv" v-if="middleAdbanner" @click="middleAdClick(middleAdbanner.linkUrl)"><img :src="middleAdbanner.iconUrl | imageToHttps" alt="" /></div>

                <!-- 金刚区 -->
                <kingKong v-if="homeConfig.kingKongEnable" :items="kingkongs" :bgInfo="kingsColor"/>

                <!-- 附近好店 -->
                <nearbyShop v-if="homeConfig.shopEnable" :type="nearbyType" :store="nearbyStore" :mstore="memberStore" :productImgUrl="storeProductImg" :storelength="mstoreLength"/>

                <!-- 优惠券 -->
                <couponItems :items="couponList"/>

                <!-- 营销区  -->
                <div class="market-area" v-if="homeConfig.marketingEnable">
                  <marketArea :refresh="refreshCount" :one="flexareaInfo.one" :two="flexareaInfo.two" :three="flexareaInfo.three"/>
                </div>
              </div>
              <!-- 分类商品tab及列表 -->
              <div id="btmWaterFullWarp" class="btm-waterfull-warp">
                <newBtmProducts v-if="homeConfig.waterfallConfig == 'personalized'"/>
                <btmProducts v-if="homeConfig.waterfallConfig == 'tradition'" :location="location" />
              </div>
            </van-pull-refresh>
          </div>

      </div>
      <!-- other -->
      <div v-else class="other-slide">
        <categorySearchList :categoryName="curCategoryName" :categoryId="curTab" fixedTop="2.52rem"/>
      </div>
    </template>
    <!-- 优惠券弹窗 -->
    <couponActivitysDialog />
    <!-- 返回顶部 -->
    <top-feedBack :isShow="showTotop" @hiddenFeedBack="hiddenFeedBack" @toTop="toGotop"></top-feedBack>
    <rules-change-remind :show="rulesChangeRemindShow" :list="remindList" @confirm="confirm" @cancle="cancle"></rules-change-remind>
  </div>
</template>

<script>
import skeleton from '@/components/skeleton/home'
import headerTopBar from './components/headerTopBar.vue'
import tabNav from './components/tabNav.vue'
import refreshLoading from '@/components/refreshLoading'
import menuItems from './components/menuItems.vue'
import kingKong from './components/kingkongItems.vue'
import nearbyShop from './components/nearbyShop'
import couponItems from './components/couponItems'
import marketArea from './components/marketArea'
import btmProducts from './components/btmProducts'
import newBtmProducts from './components/newBtmProducts'
import categorySearchList from '../../components/categorySearchList/index.vue'
import couponActivitysDialog from './components/couponActivitysDialog'
import topFeedBack from '@/components/top-feedBack/index'
import { mapGetters } from 'vuex'
import rulesChangeRemind from '@/components/rulesChangeRemind/index'
import mixins from '@/components/ruleRemind'

import Api from './api';
import { domBgColorSet, categoryNav } from './common'

export default {
  name: 'newhome',
  mixins: [mixins],
  components: {
    skeleton,
    headerTopBar,
    tabNav,
    refreshLoading,
    menuItems,
    kingKong,
    nearbyShop,
    couponItems,
    marketArea,
    btmProducts,
    newBtmProducts,
    categorySearchList,
    couponActivitysDialog,
    topFeedBack,
    rulesChangeRemind,
  },
  data() {
    return {
      refreshCount: 1,
      skeletonLoading: true,
      homeConfig: {}, // 首页各区展示配置
      curTab: 'home', // 当前tab
      curSwiperIndex: 0, // 当前swiper index
      curCategoryName: '',
      tabList: categoryNav,
      tabListFixed: {
        title: '分类'
      }, // 分类tab固定区
      headerBg: {
        backgroundType: 2,
        background: '#2878FF',
        transparency: 100,
      }, // 背景类型  1跟随banner  2背景色  3背景图  4左右渐变  5上下渐变  6透明
      middleBg: {}, // 中部背景
      bottomBg: {}, // 底部背景
      categoryBgColor: {}, // 分类区背景
      kingsColor: {}, // 金刚区背景
      searchInfo: {
        words: ['千万商品中搜索'],
        edit: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/edit_v1.png',
        kefu: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/kefu_v1.png',
        cart: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/cart_v1.png',
        cartnum: '',
        more: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/new/more_v1.png'
      },

      isLoading: true,
      bannerList: [], // banner
      // 分类菜单
      categorys: [
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-cate-bingxiang.png', name: '冰箱' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-cate-xiyiji.png', name: '洗衣机' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-cate-kongtiao.png', name: '空调' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-cate-reshuiqi.png', name: '热水器' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-cate-dianshi.png', name: '电视' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-cate-chufangdadian.png', name: '厨房大电' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-cate-shenghuodianqi.png', name: '生活电器' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-cate-jiajujiazhuang.png', name: '家具家装' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-cate-zhinengchanpin.png', name: '智能产品' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-cate-gengduo.png', name: '更多' }
      ],
      // 金刚区
      kingkongs: [
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-kings-couon-center.png', name: '领券中心', linkUrl: '/voucher' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-kings-fqg.png', name: '分期购', linkUrl: '/bannerCustom?id=554' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-kings-hezx.png', name: '海尔智选', linkUrl: '/specialtyStore' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-kings-scene.png', name: '场景超市', linkUrl: '/scene' },
        // {iconUrl: require('@/assets/images/new/k_05.png'), name: '每日榜单', linkUrl: '/voucher'},
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-kings-zhibo-new.png', name: '直播广场', linkUrl: 'https://uplus.haier.com/uplusapp/weihou/index.html?tabType=live' },
        { iconUrl: 'https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/home/home-kings-mofang.png', name: '智家魔方', linkUrl: '/bannerCustom?id=1971' },
      ],
      couponList: [], // 优惠券
      middleAdbanner: null, // 中通图banner

      nearbyStore: {}, // 附近店铺
      memberStore: [], // 会员店铺
      nearbyType: 4, // 会员类型 0新用户  1老用户 2特殊用户 4无身份
      storeProductImg: [], // 店客关系为0 的商品数据
      mstoreLength: 0, // 店铺数量

      flexareaInfo: {}, // 营销区域信息

      showTotop: false, // 回到顶部
      hasUnreadMsg: false, // 是否有未读消息
    }
  },
  created(){
    if(this.$util.isLarkApp()){
      this.$router.push('/internalChannel')
      return;
    }
  },
  mounted() {
    // 商城启动埋点
    gio('track', 'MB10626')
    // 滚动到顶部事件监听
    document.getElementById('app-warp').addEventListener('scroll', this.bindScroll);
  },
  activated() {
    this.init()
  },
  destroyed() {
    document.getElementById('app-warp').removeEventListener('scroll', this.bindScroll);
  },
  computed: {
    ...mapGetters({
      location: 'getlocationInfo',
    }),
  },
  methods: {
    init() {
      this.fetchUserCartInfo()
      this.onRefresh()
      this.getUnreadMsgCount()
    },
    onRefresh () {
      this.refreshCount += 1
      let homeConfig = Api.getHomeConfig().then(({ data }) => {
        console.log('homeConfig ==>', data)
        let result = data;
        if (result.success) {
          this.homeConfig = result.data
          // this.homeConfig.waterfallConfig = 'personalized'
          // this.homeConfig.tabEnable = 0
        }
        return Promise.resolve(1)
      })

      let tabCategory = Api.getCategoryTab().then(({ data }) => {
        console.log('tabCategory==>', data)
        let result = data;
        if (result.success) {
          this.tabList = result?.data?.slideTabList.map(item => {
            item.productCateId = item?.hyperParam?.replace('productCateId=', '') || 'home'
            item.name = item.title
            return item
          })
          this.tabListFixed = result?.data?.fixedTabList[0]
          this.setBgDivHeight()
          console.log(this.tabList)
        }
        return Promise.resolve(1)
      })

      // 获取活动配置背景及主题色信息
      let bgInfo = Api.getActivityBgInfo().then(res => {
        let result = res.data.data || {}
        console.log('bgInfo==>', result)
        this.headerBg = result.head_bg || {}
        this.middleBg = { ...result.middle_bg, transparency: 100 }
        this.bottomBg = result.bottom_bg || {}
        this.categoryBgColor = result.keyword_bg || {}
        this.kingsColor = result.kingKong_bg || {}
        if (!this.middleBg.enableBanner) {
          this.setBgDivHeight()
          domBgColorSet(this.middleBg, 'homeWarp')
        }
        // banner
        return Api.getBanner({
          itemsId: 108,
          provinceId: this.location.provinceId,
          cityId: this.location.cityId,
          regionId: this.location.districtId,
          street: this.location.townshipId,
          notSupportMPassFlag: 1,
        }).then(res => {
          let { data, success } = res.data;
          console.log('banner==>', data)
          if (success) {
            this.bannerList = data;
          }
          this.$nextTick(() => {
            domBgColorSet(this.headerBg, 'tabNav')
            this.swiperChange(this.curSwiperIndex)
            this.setBgDivHeight()
          })
          return Promise.resolve(1)
        })
      })

      // 关键词
      let searchWord = Api.getDefaultSearchWord().then(res => {
        this.searchInfo.words = res.data.data
        return Promise.resolve(1)
      })

      // 顶部导航栏图标配置
      Api.getTopSearchBar().then(res => {
        let result = res.data.data
        if (result) {
          this.searchInfo.logo = result.mall_icon?.iconUrl;
          // TODO
          this.searchInfo.kefu = result.custom_icon?.iconUrl;
          this.searchInfo.cart = result.cart_icon?.iconUrl;
          this.searchInfo.more = result.more_icon?.iconUrl;
        }
      })

      // 分类
      let categorys = Api.getCategoryItems().then((res) => {
        let result = res.data;
        if (result.success && result.data && result.data.length) {
          // TODO
          let displaySetting = this.homeConfig?.categoryInfo?.displaySetting
          this.categorys = result.data.splice(0, displaySetting === '1*5' ? 5 : 10)
        }
        this.setBgDivHeight()
        return Promise.resolve(1)
      })

      // 中通广告
      let middleAd = Api.getMiddleBanner().then(res => {
        let result = res.data;
        if (result.success) {
          this.middleAdbanner = result.data[0]
        }
        this.setBgDivHeight()
        return Promise.resolve(1)
      })

      // 金刚区
      let kingkongs = Api.getKingKongs().then((res) => {
        let result = res.data;
        if (result.success && result.data.length) {
          // TODO
          this.kingkongs = result.data
        }
        this.setBgDivHeight()
        return Promise.resolve(1)
      })

      // 附近店铺
      let nearby = this.$store.dispatch('doLocation').then(({ latitude, longitude }) => {
        console.log(latitude, longitude, 'latitude,longitude')
        return Api.getNearbyShop({
          latitude: latitude || this.$store.state.locationInfo.latitude,
          longitude: longitude || this.$store.state.locationInfo.longitude,
        }).then(res => {
          let result = res.data;
          // console.log(result)
          this.mstoreLength = result.data.memberStore && result.data.memberStore.length
          this.memberStore = result.data.memberStore && result.data.memberStore.splice(0, 5)
          this.nearbyStore = result.data.nearbyNiceStoreVO
          this.nearbyType = result.data.memberIdentify
          if (this.nearbyType === 0) {
            this.getNewsProductImg()
          }
          this.setBgDivHeight()
          return Promise.resolve(1)
        })
      }).catch(e => console.log(e))

      // 优惠券
      let coupons = Api.getCouponStatus().then(res => {
        let result = res.data;
        if (result.data && result.data.enableCoupon) {
          return Api.getCouponList({
            couponCateId: '',
            streetId: this.location.townshipId
          }).then(resp => {
            let result = resp.data
            // console.log(result)
            this.couponList = result.data || []
            this.setBgDivHeight()
            return Promise.resolve(1)
          })
        } else {
          return Promise.resolve(1)
        }
      }).catch(e => console.log(e))

      // 营销区配置数据
      let flexarea = Api.getFlexArea({
        hyperTypeVersinon: 1, // 区分新老版本
        notSupportMPassFlag: 1,
      }).then(res => {
        let result = res.data;
        if (result.data && result.data.length) {
          let one = [];
          let two = [];
          let three = []
          result.data.forEach(item => {
            if (item.area === 1) {
              one.push(item)
            }
            if (item.area === 2) {
              two.push(item)
            }
            if (item.area === 3) {
              three.push(item)
            }
          })
          this.flexareaInfo.one = one.sort((a, b) => a.sort - b.sort).splice(0, 2)
          this.flexareaInfo.two = two.sort((a, b) => a.sort - b.sort).splice(0, 4)
          this.flexareaInfo.three = three.sort((a, b) => a.sort - b.sort).splice(0, 2)
          this.setBgDivHeight()
        }
      }).catch(e => console.log(e))

      Promise.race([homeConfig, tabCategory, searchWord, bgInfo, categorys, middleAd, kingkongs, nearby, coupons, flexarea]).then((values) => {
        this.skeletonLoading = false
        this.$util.setTimeOutFn(() => {
          this.isLoading = false;
        }, 300)
        console.log(values, '===============');
      }).catch((err) => {
        console.log('err race =>', err)
        this.isLoading = false;
        this.skeletonLoading = false
      });
    },

    swiperChange(index) {
      this.curSwiperIndex = index
      if (this.headerBg.enableBanner && this.bannerList[index] && this.bannerList[index].backgroudColor) {
        let headerBg = {
          ...this.headerBg,
          background: this.bannerList[index].backgroudColor,
          backgroundType: 2,
          transparency: 100
        }
        domBgColorSet(headerBg, 'topWarp', '3.36rem')
        domBgColorSet(headerBg, 'tabNav')
      } else {
        domBgColorSet(this.headerBg, 'topWarp', '3.36rem')
        domBgColorSet(this.headerBg, 'tabNav')
      }
      if (this.middleBg.enableBanner && this.bannerList[index] && this.bannerList[index].backgroudColor) {
        let middleBg = {
          ...this.middleBg,
          backgroundType: 2,
          background: this.bannerList[index].backgroudColor
        }
        domBgColorSet(middleBg, 'homeWarp')
        this.setBgDivHeight()
      } else {
        domBgColorSet(this.middleBg, 'homeWarp')
        this.setBgDivHeight()
      }

      // if (this.bottomBg.enableBanner && this.bannerList[index].backgroudColor) {
      //   this.bottomBg.background = this.bannerList[index].backgroudColor
      //   this.bottomBg.transparency = 100
      // }

      if (this.categoryBgColor.enableBanner) {
        this.categoryBgColor.background = this.bannerList[index]?.backgroudColor || this.bottomBg.background
      }
      if (this.kingsColor.enableBanner) {
        this.kingsColor.background = this.bannerList[index]?.backgroudColor || this.kingsColor.background
      }
    },

    bannerClick(item, index) {
      console.log('bannerClick:', item);
      console.log('bannerClick index:', index + 1);

      const { hyperType, hyperParam, hyperLinkType, hyperLink, relationId } = item;
      console.log('bannerClick-hyperLink:', hyperLink, hyperLinkType);

      // 埋点
      this.$util.gioTrackWithVariable('MB15592', {
        site_number: index + 1 + '',
        activity_id: item?.param?.bannerId || 'null',
        activity_type: item?.param?.activityType || 'null'
      })

      if (hyperType) {
        this.$store.dispatch('goPageByType', {
          type: Number(hyperType),
          params: hyperParam,
        })
      } else {
        this.$store.dispatch('bannerClick', { hyperLinkType, hyperLink, relationId });
      }
    },

    /**
     * 店客关系为0，请求数据上新数据
     */
    getNewsProductImg(storeId) {
      console.log('+++++aa++++++')
      Api.getCommonLoadItemNew({
        channal: 1,
        provinceId: this.location.provinceId,
        cityId: this.location.cityId,
        districtId: this.location.districtId,
        streetId: this.location.townshipId,
        visitStore: this.nearbyStore?.storeId || '',
        visitMdCode: this.nearbyStore?.mdCode || '',
        filterData: 'hasStock@all@0@',
        qs: 'saleDesc',
        fromType: 2,
        pageIndex: 1,
        pageSize: 10,
        longitude: this.location.longitude || '',
        latitude: this.location.latitude || '',
      }).then(res => {
        let result = res.data;
        console.log('==============', result)
        if (result.success) {
          this.storeProductImg = (result.data && result.data.productList && result.data.productList.splice(0, 4)) || []
        } else {
          this.storeProductImg = []
        }
      }).catch(() => {
        this.storeProductImg = []
      })
    },

    /**
     * 获取用户购物车信息
     */
    fetchUserCartInfo() {
      if (this.$store.state.isLogin) {
        Api.getCartNumber().then(({ data }) => {
          let len = data.data;
          this.searchInfo.cartnum = len > 99 ? '99+' : len
        })
      }
    },

    changeTab(tab, ev) {
      this.$util.gioTrackWithVariable('WBSC20005', {
        search_words: tab.name
      })
      this.curTab = tab.productCateId;
      this.curCategoryName = tab.name
      this.$nextTick(() => {
        ev?.target?.scrollIntoView?.({ behavior: 'smooth', inline: 'center', block: 'nearest' })
        this.$util.setTimeOutFn(this.toGotop)

        this.swiperChange(this.curSwiperIndex)
      })
    },

    hiddenFeedBack() {
      this.showTotop = false
    },
    bindScroll(ev) {
      let scrollTop = ev.target.scrollTop
      // console.log('scrollTop', scrollTop)
      if (scrollTop > 20) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
      if (scrollTop > 200) {
        this.showTotop = true
      } else {
        this.showTotop = false
      }
    },

    /**
     * 回到顶部
     */
    toGotop() {
      this.scrollSmoothTo(0)
    },
    /**
     * 模拟动画滚动
    */
    scrollSmoothTo(position) {
      console.log('#app-warp scroll')
      if (!window.requestAnimationFrame) {
        window.requestAnimationFrame = function(callback) {
          return setTimeout(callback, 17);
        };
      }
      // debugger
      let _target = document.querySelector('#app-warp')
      // 当前滚动高度
      let scrollTop = _target.scrollTop;
      console.log(scrollTop, 'scrollTop')
      // 滚动step方法
      let step = function () {
        // 距离目标滚动距离
        var distance = position - scrollTop;
        // 目标滚动位置
        scrollTop = scrollTop + distance / 10;
        if (Math.abs(distance) < 1) {
          _target.scrollTo(0, position);
        } else {
          _target.scrollTo(0, scrollTop);
          requestAnimationFrame(step);
        }
      };
      step();
    },
    /**
     * 中通图广告跳转
     */
    middleAdClick(path) {
      this.$util.gioTrackWithVariable('MB15594')
      location.href = path
    },
    /**
     * 动态计算设置背景高度
     */
    setBgDivHeight() {
      this.$util.setTimeOutFn(() => {
        let offsetTop = document.getElementById('btmWaterFullWarp') && document.getElementById('btmWaterFullWarp').offsetTop
        let headerHeight = document.getElementById('topWarp') && document.getElementById('topWarp').offsetHeight
        let homeWarp = document.getElementById('homeWarp')
        if (homeWarp) {
          homeWarp.style.height = (offsetTop + headerHeight + 40) + 'px'
        }
      })
    },
    /**
     * 获取是否存在未读消息
     */
    getUnreadMsgCount() {
      if (this.$store.state.isLogin) {
        Api.getUnreadMsgCount().then(({ data }) => {
          this.hasUnreadMsg = !!data?.data
        })
      }
    },
  },

}
</script>

<style lang="scss" scoped>
.home{
  height: 100%;
}

:deep(.home-container) {
  position: relative;
  padding-top: 1.75rem;
  box-sizing: border-box;
}

:deep(.home-warp) {
  min-height: 100%;
}

:deep(.middle-bg) {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /* min-height: 100vh; */
  z-index: 0;
}

.home-banner{
  margin: .24rem .32rem;
  margin-top: .08rem;
  width: 6.86rem;
  height: 2.8rem;
  overflow: hidden;
  border-radius: .24rem;
}
.banner{
  height: 2.8rem;
  overflow: hidden;
  border-radius: .24rem;
  img{
    width: 6.86rem;
    height: 2.8rem;
  }
}

.home-body{
  padding-bottom: .1rem;
}

.home-body-pt{
  padding-top: .1rem;
}

:deep(.other-slide) {
  padding-top: 3.5rem;
  height: 100%;
  box-sizing: border-box;
}

.middle-adv {
  padding: 0 .24rem;
  img{
    width: 100%;
  }
}

.market-area{
  margin: .12rem .32rem .12rem .32rem;
  background: #fff;
  border-radius: .24rem;
  overflow: hidden;
  @include synShadow;
}

.flex-warp{
  margin-top: 0;
  display: flex;
  overflow: hidden;
  padding-left: .2rem;
}
.flex-item{
  flex: 1;
}

.btm-waterfull-warp{
  background: #f5f5f5;
}
::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
:deep(.van-popup--bottom) {
  border-radius: 0.24rem 0.24rem 0 0;
}
</style>
